export default {
  order_reference: "Order reference",
};
